/* global window */

import { withExtraArgument } from 'redux-thunk';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import authRequestMiddleware from 'Middlewares/auth';
import apiMiddleware from 'Middlewares/apiMiddleware';
import * as server from './server';
import reducers from './reducers';
import fetchPonyfill from 'fetch-ponyfill';
import { isEmpty } from 'Helpers/objects';
const { fetch } = fetchPonyfill();

let states = {};
let withLegionSessionMigration = false;
let composeEnhancers = compose;
const trackingHandler = () => {};

let config = {};

if (typeof window !== 'undefined') {
    states = window.__APP.states;
    const { login: { enableSessionMigrationCoreToLegion = false } = {}} = window.__APP.config || {};

    config = window.__APP.config || {};
    withLegionSessionMigration = enableSessionMigrationCoreToLegion;

    if (DEBUG && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) { // eslint-disable-line
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
    // if (window.newrelic) {
    //     trackingHandler = window.newrelic.addPageAction;
    // }
}
const thunk = withExtraArgument({
    ...server,
    config
});
const enhancer = composeEnhancers(applyMiddleware(authRequestMiddleware(trackingHandler, withLegionSessionMigration), apiMiddleware(fetch), thunk));
const staticReducers = reducers;

export function configureStore(customState = {}) {
    const preloadedState = isEmpty(customState) ? states : customState;
    const storeObj = createStore(createReducer(), preloadedState, enhancer);

    // Add a dictionary to keep track of the registered async reducers
    storeObj.asyncReducers = {};

    // Create an inject reducer function
    // This function adds the async reducer, and creates a new combined reducer
    storeObj.injectReducer = (key, asyncReducer) => {
        if (!storeObj.asyncReducers[key]) {
            storeObj.asyncReducers[key] = asyncReducer;
            storeObj.replaceReducer(createReducer(storeObj.asyncReducers));
        }
    };

    // Return the modified store
    return storeObj;
}

function createReducer(asyncReducers) {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers
    });
}

const store = configureStore();

export default store;
